import { module } from 'angular';
import SearchFactory from '~/components/search-bar/search.factory';
import component from './search-bar.component';
import popInfoComponent from './pop-info/pop-info.component';
import './search-bar.scss';

export default module('app')
	.service('Search', SearchFactory)
	.component('searchBar', component)
	.component('popInfo', popInfoComponent)
	.name;
